import React from 'react';

export default function Robot(props) {
  return (
      <svg width="100%" height="100%" viewBox="0 0 276 226" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '1.41421'}} {...props}>
      <path d="M38.6,99.4L38.6,206.5L57.4,225.3L218.7,225.3L237.5,206.5L237.5,99.4C237.4,44.5 192.9,0 138,0C83.1,0 38.6,44.5 38.6,99.4ZM210.6,182.2L195.3,182.2L195.3,200.1L210.6,200.1L210.6,182.2ZM106.7,164L91.4,164L91.4,199.8L106.7,199.8L106.7,164ZM132.6,149L117.3,149L117.3,199.8L132.6,199.8L132.6,149ZM158.6,157.2L143.3,157.2L143.3,199.8L158.6,199.8L158.6,157.2ZM184.6,167.7L169.3,167.7L169.3,199.8L184.6,199.8L184.6,167.7ZM80.7,177.8L65.4,177.8L65.4,199.6L80.7,199.6L80.7,177.8ZM275.9,140.5L259.6,188.7L245.9,188.7L245.9,92.2L259.6,92.2L275.9,140.5ZM16.3,92.2L30.1,92.2L30.1,188.7L16.3,188.7L0,140.5L16.3,92.2ZM207.6,92.2L68.4,92.2C66.7,92.2 65.4,93.5 65.4,95.2L65.4,122.5C65.4,124.2 66.7,125.5 68.4,125.5L207.6,125.5C209.2,125.5 210.6,124.2 210.6,122.6L210.6,95.2C210.6,93.5 209.2,92.2 207.6,92.2Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/vectors/Robot.js